import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { IImage } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/admin/images';
const $urlDownload = '/admin/images/actions/download';
const $urlCheck = '/admin/images/actions/check';

interface ISearchRequest {
  offset: number;
  limit: number;
  keyword: string;
}

interface ISearchResult {
  images: IImage[];
  count: number;
}

export default {
  get(req: ISearchRequest, success: (res: ISearchResult) => void) {
    utils.loading(true);
    request
      .get($url, {
        params: req,
      })
      .then((response: AxiosResponse<ISearchResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delete(id: number, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .delete($url, {
        data: {
          id,
        },
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  download(success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlDownload)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  check(success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlCheck)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
